import { generatePath, Navigate } from "react-router-dom";
import { REQUEST_WEEKEND_WORK_EDIT_PATH } from "@/modules/requests/pages/weekend-work-request";

export function OpenWeekendWorkRequest() {
  return (
    <Navigate
      to={generatePath(REQUEST_WEEKEND_WORK_EDIT_PATH, {
        id: new URL(window.location.href).searchParams.get("id"),
      })}
    />
  );
}
